import React, {useEffect, useState, useRef} from 'react';
import PhoneInput from 'react-phone-input-2';
import './css/country-code.css';

let $vars=JSON.parse(JSON.stringify(window.WADMOPTL_vars), (key, value)=>value==='true'?true:value==='false'?false:value), 
		$id=$vars.handler_id;

$vars.codes=~~$vars.verify['count-down']===0?false:Array.from({length:6}, ()=>false);

const Tabs=(props)=>{

	let NewActive;

	const {id, active, Submit, UsingPassword, SetActive, SetUsingPassword}=props;

	const HandleClick=(e, index)=>{
		if(Submit)return;
		NewActive={...active};
		NewActive[id]=index;
		SetActive(NewActive);
	}

	return (
		<>
			<div className="tabs">
				{$vars['input-types'].map((item, key)=>(
					<div
						key={key}
						className={item===active[id]?'active':''}
						>
						<a
							href="/#"
							data-type={id+'-'+item}
							onClick={(e)=>HandleClick(e, item)}
							>
							{$vars.tabs[id][item]}
						</a>
					</div>
				))}
			</div>
			{$vars['input-types'].map((item, key)=>(
				<InputBlock
					key={key}
					item={item}
					{...props}
					UsingPassword={UsingPassword}
					SetUsingPassword={SetUsingPassword}
					/>
			))}
		</>
	);
}

const Hint=(props)=>{
	const {error, active, id, node}=props;
	return (
		<p>{error[id][active[id]][node]}</p>
	);
}

const AfterTabs=(props)=>{

	let data, 
			strPostData, 
			strExtendData, 
			NewResult={};

	const {id, active, values, result, phone, Submit, UsingPassword, SetSubmit, SetError, SetResult, SetAuthCode, SetPhone, SetPostData}=props;

	const CheckValues=()=>{

		let reg=/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, 
				collect=[], 
				collected=[], 
				type={}, 
				ue=false;

		let NewError=structuredClone($vars['default-fields']), 
				CurrentForm;

		CurrentForm=document.getElementById($id+'-'+id);
		CurrentForm=CurrentForm.querySelector('.field > .active');

		data=values[id][active[id]];

		[].forEach.call(Object.keys(data), (node, index)=>{

			if(UsingPassword===false&&node==='password-mobile')return;

			if(data[node].length===0||data[node]===0){
				type[node]=$vars.message.empty;
				collect.push(type);
				collected.push(node);
			}

		});

		SetSubmit(true);
		if(result.status!==false){
			SetResult({...$vars.result});
		}

		switch(active[id]){
			case 'email':
				ue=Object.keys(data)[0];
				if(collected.indexOf(ue)<0&&reg.test(data[ue])===false&&ue.length>0){
					type[ue]=$vars.message['wrong-format'];
					collect.push(type);
				}
				break;
			case 'mobile':
				break;
			default:
		}

		strPostData=CollectInputs(CurrentForm);
		if(strPostData.length>0)strPostData+='&';

		if(collect.length>0){

			[].forEach.call(collect, (node, index)=>{
				[].forEach.call(Object.keys(node), (xnode, eq)=>{
					NewError[id][active[id]][xnode]=node[xnode];
				});
			});

			SetError(NewError);
			SetSubmit(false);

		}else{

			if(active[id]==='mobile')data['mobile-no']=phone;

			data['woocommerce-'+id+'-nonce']=$vars.nonce[id];
			data['submit-type']=id;
			data['submit-by']=active[id];

			console.log(1, Object.entries(data));

			strExtendData=Object.entries(data).filter((value)=>{
				if(value[1]===0||value[1]==='0')return false;
				return true;
			}).map((value)=>{
				return value[0]+'='+value[1];
			}).join('&');

			strPostData+=strExtendData;

			console.log('strPostData[2]', strPostData);

			SetPostData(strPostData);

			RequestFetch(strPostData) // 驗 register|log in

				.then(res=>{

					console.log('res[5]', res);

					if(res.success){
						$vars.verify['count-down']=res.data['count-down'];
						NewResult.status='success';

					}else{
						NewResult.status='error';
						SetSubmit(false);
					}

					NewResult.message=res.data.message;

					if(res.data.message.length>0){
						SetResult(NewResult);
					}

					// if(res.success&&id==='register'&&active[id]==='mobile'){
					if(res.success&&res.data.hasOwnProperty('count-down')&&active[id]==='mobile'){
						SetAuthCode([...Array(6)]);
						SetPhone(res.data['mobile-no']);
					}

					MaybeRedirect(res.data);

				});
		}
	}

	return (
		<button
			type="submit"
			name={id}
			value=""
			onClick={CheckValues}
			disabled={Submit===true?'disabled':''}
			>
			{$vars['text'][id]}
		</button>
	);
}

const CollectInputs=CurrentForm=>{

	let selected;
	let FormData;

	const inputs=CurrentForm.querySelectorAll('input, select, textarea');

	FormData=Array.from(inputs).filter((input)=>{

		if(input.type==='checkbox'||input.type==='radio')return input.checked;
		if(input.name.length===0)return false;
		return true;

	}).map((input)=>{
		if(input.tagName.toLowerCase()==='select'&&input.multiple){
			selected=Array.from(input.options).filter(option=>option.selected);
			return input.name+'[]='+selected.map(option=>option.value);
		}else{
			return input.name+'='+input.value;
		}
	}).join('&');

	return FormData;

}

const MaybeRedirect=res=>{
	if(res.hasOwnProperty('redirect-url')){
		setTimeout(()=>{
			window.location=res['redirect-url'];
		}, 1500);
	}
}

const RequestFetch=async(data)=>{
	const url=$vars['api-url'];
	const settings={
		method:'POST', 
		body:JSON.stringify(data), 
		headers:{
			'Content-Type':'application/json',
		}
	};
	const res=await fetch(url, settings);
	return res.json();
};

const InputBlock=(props)=>{

	const {active, id, item, error, UsingPassword, SetUsingPassword}=props;

	const i=$vars['place-holder'][item];

	const PasswordField=(array, index)=>{

		if(id==='login'&&array[0]==='password-mobile'&&UsingPassword===false)return null;

		return (
			<div
				className={error[id][item][array[0]]!==0?'row error':'row'}
				key={index}
				>
				<InputField
					node={array[0]}
					i={i}
					{...props}
					/>
			</div>
		)
	}

	return (
		<>
			<div
				className={active[id]===item?'active':''}
				data-type={id+'-'+item}
				>
				{Object.entries(i).map((array, index, arrCurrentData)=>PasswordField(array, index)) /* ****** */ }
				{
					id==='login'
					&&
					<div data-field="using-password">
						{
							item==='mobile'&&$vars['enable-auth']==='yes'
							&&
							<label htmlFor={$id+'-use-password'}>
								<input
									type="checkbox"
									id={$id+'-use-password'}
									name={$id+'-use-password'}
									onClick={(e)=>SetUsingPassword(!UsingPassword)}
									/>
								<span>透過密碼登入</span>
							</label>
						}
						{
							id==='login'
							&&
							<div className="lost-password">
								<a href={$vars['lost-password'].url}>{$vars['lost-password'].text}</a>
							</div>
						}
					</div>
				}
			</div>
		</>
	);
}

const InputField=(props)=>{

	let NewData, 
			NewInput='', 
			NewError;

	const {id, active, item, node, i, error, values, Submit, SetValues, SetError}=props;

	const strType=node.indexOf('password-')===0?'password':'text';

	// const [Type, SetType]=useState('text');
	const [Type, SetType]=useState(strType);

	const [InputText, SetInputText]=useState('');

	const TogglePassword=e=>{
		if(Submit)return;
		SetType(Type==='text'?'password':'text');
	}

	/*
	console.log(1, node);
	if(node.indexOf('password-')===0){
		SetType('password');
		console.log(Type);
	}
	*/

	const CheckInput=(e)=>{

		let value=e.target.value, 
				name=e.target.name;

		switch(name){

			case 'mobile-no':

				NewInput=value;

				if(((value.length===1&&value==='0')||(value.length>1&&value.indexOf('09')===0))&&(/\d+/.test(value))===true&&value.length<=10){
					NewInput=value;
				}else{
					NewInput=value.length===0?'':InputText;
				}

				break;

			default:
				NewInput=value;

		}

	}

	const HandleChange=(e)=>{

		CheckInput(e);
		SetInputText(NewInput);

		NewError={...error};
		NewError[id][active[id]][e.target.name]=0;
		SetError(NewError);

		NewData={...values};

		NewData[id][item][e.target.name]=NewInput;

		SetValues(NewData);

	}

	const HandleKeyUp=e=>{
		if(['Enter'].includes(e.key)===false)return;
		document.querySelector('button[name="'+id+'"]').click();
	}

	const OutputField=()=>{

		if(node.indexOf('mobile-no')===0){
			return (
				<>
				<PhoneField {...props} />
				{error[id][item][node]!==0&&<Hint {...props} />}
				</>
			);
		}else{
			return (
				<>
					<input
						type={Type}
						name={node}
						placeholder={i[node][1]}
						value={InputText}
						onChange={HandleChange}
						onKeyUp={HandleKeyUp}
						className={error[id][item][node]===0?'':'error'}
						disabled={Submit===true?'disabled':''}
						/>
					{node.indexOf('password-')===0&&<a href="/#" data-action="toggle-password" onClick={TogglePassword}><i></i></a>}
					{error[id][item][node]!==0&&<Hint {...props} />}
				</>
			);

		}
	}

	return OutputField(node);
}

const PhoneField=(props)=>{

	let NewData, 
			NewError;

	const {Submit, active, error, id, item, values, SetValues, SetError, SetPhone}=props;

	// const [phone, SetPhone]=useState('');
	const [phone]=useState('');

	const HandleChange=(phone, data, e, FormattedValue)=>{

		NewError={...error};
		NewError[id][active[id]]['mobile-no']=0;
		SetError(NewError);

		NewData={...values};

		NewData[id][item]['mobile-no']=FormattedValue;
		SetValues(NewData);

		SetPhone(FormattedValue);

	}

	return (
		<PhoneInput
			country={'tw'}
			enableSearch={true}
			value={phone}
			onChange={(phone, data, e, FormattedValue)=>HandleChange(phone, data, e, FormattedValue)}
			disabled={Submit===true?'disabled':''}
			/>
	);
}

const Flip=(props)=>{

	const [UsingPassword, SetUsingPassword]=useState(false);

	const {Submit, id, SetDataFrom}=props;

	const texts=Object.keys($vars.text).sort(), 
				next=id==='login'?1:0;

	const AnchorText=()=>{
		return $vars.text[texts[next]];
	}

	const HandleClick=e=>{
		if(Submit)return;
		document.getElementById('wadm-otpl-flip').classList.toggle('active');
		SetDataFrom(texts[next]);
	}

	return (
		<div
			id={'wadm-otpl-'+id}
			>
			<div className="top">
				<h3>{$vars.text[id]}</h3>
				<a href="/#" data-flip="register" onClick={HandleClick}>
					{AnchorText()}
				</a>
			</div>
			<div className="field">
				<Tabs
					{...props}
					UsingPassword={UsingPassword}
					SetUsingPassword={SetUsingPassword}
					/>
				<AfterTabs
					{...props}
					UsingPassword={UsingPassword}
					/>
			</div>
		</div>
	);
}

const Alert=(props)=>{

	const {result}=props;

	if(result.status===false)return false;

	return (
		<nav id="wadm-otpl-status">
			<div className={result.status} dangerouslySetInnerHTML={{__html:result.message}}></div>
		</nav>
	);

}

const FlipField=(props)=>{

	const {AuthCode, DataFrom}=props;

	if(AuthCode!==false)return false;

	return (
		<>
			<div
				id="wadm-otpl-flip"
				{...(DataFrom===undefined?{'data-from':DataFrom}:{})}
				className={DataFrom==='register'?'active':''}
				>
				{['login', 'register'].map((item, key)=>(
					<Flip
						key={key}
						id={item}
						{...props}
						/>
				))}
			</div>
		</>);
	
}

const ProcessCountDown=(props)=>{

	const {time, minute, second, SetSeconds}=props;

	const interval=setInterval(()=>{

		SetSeconds(()=>{

			time.current--;
			if(time.current<0)time.current=0;

			minute.current=Math.floor(time.current/60);
			second.current=time.current%60;

			if(time.current===0){
				// SetCountDown(false);
				clearInterval(interval);
				return;
			}

			return minute.current.toString().padStart(2, '0')+':'+second.current.toString().padStart(2, '0');

		});

	}, 1000);

	return ()=>clearInterval(interval);
	
}

const CountDownField=(props)=>{

	const time=useRef($vars.verify['count-down']);
	const minute=useRef(0);
	const second=useRef(0);

	const {ProcessAuth, sec, SetCountDown, SetSeconds}=props;

	useEffect(()=>{

		ProcessCountDown({time, minute, second, SetSeconds});

	// }, [SetSeconds, minute, second]);
	}, [SetSeconds]);

	useEffect(()=>{
		if(sec===false){
			SetSeconds(new Date(time.current*1000).toISOString().substring(14, 19));
		}else{
			if(typeof sec==='undefined')SetCountDown(false);
		}
	}, [sec, SetCountDown, SetSeconds]);

	if(sec==='00:00'||ProcessAuth)return false;
	return <span>{sec}</span>;

}

const AuthCodeField=(props)=>{

	let NewAuthCode=[], 
			NewInput=false, 
			NewResult={};

	let index, data, strPostData;

	const verify=useRef(false);
	const divs=useRef([]);
	const codes=useRef(false);

	const [CountDown, SetCountDown]=useState(true);
	const [sec, SetSeconds]=useState(false);

	const {AuthCode, ProcessAuth, PostData, phone, values, SetAuthCode, SetProcessAuth, SetResult, SetPostData}=props;

	const HandleKeyDown=(e, i)=>{

		if(/^\d+$/.test(e.key)===false&&['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)===false){
			e.preventDefault();
			return;
		}

		NewInput=e.key;
		if(AuthCode.length>0){
			NewAuthCode=structuredClone(AuthCode);
		}

		switch(e.key){
			case 'Backspace':
				NewAuthCode[i]=false;
				SetAuthCode(NewAuthCode);
				if(!(i-1<0)){
					divs.current[i-1].querySelector('input').focus();
				}
				break;
			case 'Delete':
				NewAuthCode[i]=false;
				break;
			case 'ArrowLeft':
				divs.current[i-1].querySelector('input').focus();
				break;
			case 'Tab':
				break;
			default:
				if(i+1<AuthCode.length){
					divs.current[i+1].querySelector('input').focus();
				}
		}

		if(/^\d+$/.test(e.key)===false)return;

		NewAuthCode[i]=NewInput;

		SetAuthCode(NewAuthCode);

		codes.current=NewAuthCode.filter(v=>v!==undefined&&v!==false);

		if(codes.current.length===document.querySelectorAll('.auth-input').length){

			data={
				'mobile-no':phone, 
				'password':values.register.mobile['password-mobile'], 
				'auth-code':NewAuthCode, 
				'submit-type':'auth-code', 
				'woocommerce-auth-code-nonce':$vars.nonce['auth-code']
			};

			console.log(2, Object.entries(data));

			strPostData=Object.entries(data).map((value)=>{

				const params=new URLSearchParams();

				if(Array.isArray(value[1])){

					value[1].forEach(item=>{
						params.append(value[0]+'[]', item);
					});
					return params.toString();

				}else{
					return value[0]+'='+value[1];
				}
			}).join('&');

			console.log('strPostData[3]', strPostData);

			SetPostData(strPostData);

			SetProcessAuth(true);

			RequestFetch(strPostData)
				.then(res=>{

					console.log('res[4]', res);

					if(res.success){
						NewResult.status='success';

					}else{
						NewResult.status='error';
						SetProcessAuth(false);
						SetAuthCode([...Array(6)]);
					}

					NewResult.message=res.data.message;
					SetResult(NewResult);

					MaybeRedirect(res.data);

				});

		}else{
			if(typeof divs.current[index]==='undefined')return;
		}

	}

	const HandleChange=()=>{}

	useEffect(()=>{
		verify.current=document.getElementById('wadm-otpl-verify');
		if(verify.current)divs.current=verify.current.querySelectorAll('.auth-input');

		if(AuthCode===false)return;
		codes.current=AuthCode.filter(v=>v!==undefined);
		if(codes.current.length===0){
			divs.current[0].querySelector('input').focus();
		}
	}, [AuthCode]);

	if(AuthCode===false)return false;

	$vars.verify.desc=$vars.verify.desc.replace(/\$1%s/, phone);

	return (
		<div id="wadm-otpl-verify">
			<h2>{$vars.verify.title}</h2>
			<p dangerouslySetInnerHTML={{__html:$vars.verify.desc}} />
			<div>
				{[...Array(6)].map((x, i)=>
					<div
						className="auth-input"
						key={i}
						>
						<input
							type="number"
							name={'no-'+(i+1)}
							value={AuthCode[i]||''}
							{...(i===0?{autoFocus:true}:{})}
							onKeyDown={(e)=>HandleKeyDown(e, i)}
							onChange={HandleChange}
							disabled={ProcessAuth===true?'disabled':''}
							/>
					</div>
				)}
			</div>
			<section>
				<CountDownField
					sec={sec}
					SetCountDown={SetCountDown}
					SetSeconds={SetSeconds}
					PostData={PostData}
					{...props}
					/>
				{CountDown===false?(<Resend PostData={PostData} SetSeconds={SetSeconds} SetCountDown={SetCountDown} SetProcessAuth={SetProcessAuth} SetAuthCode={SetAuthCode} SetResult={SetResult} {...props} />):null}
			</section>
		</div>
	);
}

const Resend=(props)=>{

	let NewResult={};

	const {PostData, SetSeconds, SetCountDown, SetResult, SetSubmit}=props;

	const time=useRef($vars.verify['count-down']);
	const minute=useRef(0);
	const second=useRef(0);

	const [Sending, SetSending]=useState(false);

	const HandleClick=(e)=>{

		e.preventDefault();

		SetSending(true);

		RequestFetch(PostData) // 驗 register|log in
			.then(res=>{

				SetSending(false);

				if(res.success){

					time.current=res.data['count-down'];

					ProcessCountDown({time, minute, second, SetSeconds});
					NewResult.status='success';

					$vars.verify['count-down']=res.data['count-down'];

					SetSeconds(new Date(time.current*1000).toISOString().substring(14, 19));
					SetCountDown(true);

				}else{ // ****** 需註解
					NewResult.status='error';
					SetSubmit(false);
				}

				NewResult.message=res.data.message;

				if(res.data.message.length>0){
					SetResult(NewResult);
				}

			});
	}

	return (
		<a
			href="/#"
			onClick={HandleClick}
			>
			{Sending===false?$vars.verify.resend:$vars.verify.sending}
		</a>
	);
}

const App=()=>{

	let props={};

	const DefaultActive=Object.keys($vars.tabs).reduce((node, index)=>{
		node[index]=$vars['submit-by'];
		return node;
	}, {});


	const [DataFrom, SetDataFrom]=useState($vars['submit-type']);
	const [Submit, SetSubmit]=useState(false);
	const [ProcessAuth, SetProcessAuth]=useState(false);

	const [AuthCode, SetAuthCode]=useState($vars.codes);

	const [AuthFocus, SetAuthFocus]=useState(false);
	const [PostData, SetPostData]=useState(false);

	const [active, SetActive]=useState(DefaultActive);
	const [error, SetError]=useState(structuredClone($vars['default-fields']));

	const [values, SetValues]=useState(structuredClone($vars['default-fields']));
	const [result, SetResult]=useState({...$vars.result});

	// const [phone, SetPhone]=useState(false);
	const [phone, SetPhone]=useState($vars['mobile-no']);

	const HandleClick=e=>{
		if(e.target.tagName==='A'&&e.target.getAttribute('href')==='/#')e.preventDefault();
	}

	useEffect(()=>{
		
	}, []);

	props={Submit, AuthCode, AuthFocus, ProcessAuth, DataFrom, PostData, active, error, values, result, phone, SetDataFrom, SetSubmit, SetActive, SetError, SetValues, SetResult, SetAuthCode, SetAuthFocus, SetPhone, SetProcessAuth, SetPostData};

	return (
		<div
			id="wadm-otpl-field"
			onClick={(e)=>HandleClick(e)}
			>
			<Alert {...props} />
			<AuthCodeField {...props} />
			<FlipField {...props} />
		</div>
  );
}

export default App;